import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import CartQuery from "theme/pages/Cart/CartQuery.gql";
import CartQtyQuery from "theme/layouts/Header/CartQtyQuery.gql";
import { compose, withHandlers, withProps } from "recompose";

const EnhanceRemoveItemCart = ({ RemoveCartItemMutation }) =>
  compose(
    makeCommandDispatcher({
      handleRemoveItem: (props) => (itemId, qty) => ({
        options: {
          mutation: RemoveCartItemMutation,
          variables: { item_id: itemId },
          update: (store, { data }) => {
            const response = data.removeItemFromCart;
            if (response.success) {
              const cart = response.cart;
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "er_event_remove_from_cart",
                ep: "ecommerce",
                ev: "remove from cart",
                ecommerce: {
                  currencyCode: "EUR",
                  remove: {
                    products: [
                      {
                        id: props.item.sku,
                        quantity: props.item.qty,
                      },
                    ],
                  },
                },
              });
              store.writeQuery({
                query: CartQtyQuery,
                data: {
                  cart: {
                    id: cart.id,
                    items_qty: cart.items_qty,
                    __typename: cart.__typename,
                  },
                },
              });
              store.writeQuery({
                query: CartQuery,
                data: { cart: cart },
              });
            }
          },
          refetchQueries: ["CartQty"],
        },
        callback: props.onProductRemoved,
      }),
    }),
    withHandlers({
      removeItem: (props) => () => {
        return props.handleRemoveItem(props.item.item_id, props.item.qty);
      },
    }),
    withProps((props) => ({
      removeItemStatus: {
        commandPending: props.commandPending,
        hasMessage: props.hasMessage,
        message: props.message,
        success: props.success,
      },
    }))
  );

export default EnhanceRemoveItemCart;
